<div class="popup g-popup" (cmsEscapeKey)="closePopup()">
    <header class="g-popup-header">
        <i (click)="closePopup()"
           class="g-popup-header-close g-icon g-icon-close-a"></i>
        <div class="g-popup-title">
            {{ 'list_new_item' | translate }}
        </div>
    </header>
    <div class="g-popup-body">
        <form class="popup-form"
              novalidate [formGroup]="form"
              (ngSubmit)="addListItem()">
            <div class="form-body">
                <div class="form-control">
                    <cms-select [options]="listItemTypes"
                                formControlName="listItemType"
                                [placeholder]="'common_type' | translate"
                                [title]="'common_type' | translate">
                    </cms-select>
                </div>
                <div *ngIf="resourceSelected">
                    <div class="form-control">
                        <div class="g-input g-input-io">
                            <input type="text"
                                   class="g-input-input"
                                   [placeholder]="'common_title' | translate"
                                   formControlName="title">
                            <label class="g-input-label">
                                {{ 'common_title' | translate }}
                            </label>
                        </div>
                    </div>
                    <div class="form-control">
                        <div class="resource-item-preview p-0 mb-1"
                             *ngIf="form.get('resource').value">
                            <div class="image-preview"
                                 *ngIf="(form.get('resource')?.value?.mimeType | resourceFileType) === resourceFileTypes.image"
                                 [style.background-image]="'url(' + imageUrl + ')'">
                            </div>
                            <div class="file-preview"
                                 *ngIf="(form.get('resource')?.value?.mimeType | resourceFileType) === resourceFileTypes.file">
                                <div class="icon">
                                    <i class="g-icon g-icon-full-box"></i>
                                </div>
                            </div>
                            <div class="video-preview"
                                 *ngIf="(form.get('resource')?.value?.mimeType | resourceFileType) === resourceFileTypes.video">
                                <div class="icon">
                                    <i class="g-icon g-icon-play-a"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-1">
                        <button class="g-button g-button-earth"
                                (click)="openResourcePicker()">
                            <span class="g-button-title">
                                {{ 'list_repick_resource' | translate }}
                            </span>
                        </button>
                    </div>
                </div>
                <cms-article-picker *ngIf="form.get('listItemType')?.value?.id === listItemType.article"
                                    (onArticleSelect)="onArticlesSelect($event)">
                </cms-article-picker>
                <cms-resource-picker *ngIf="form.get('listItemType')?.value?.id === listItemType.resource && !resourceSelected"
                                     class="mb-2"
                                     [options]="resourcePickerOptions"
                                     (onResourceSelect)="onResourceSelect($event)">
                </cms-resource-picker>
                <div class="form-control">
                    <div class="g-toggle g-toggle-io">
                        <input class="g-toggle-input"
                               type="checkbox"
                               formControlName="active">
                        <label class="g-toggle-label">
                            {{ 'common_active' | translate }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <div class="form-footer-buttons">
                    <button type="button"
                            class="form-footer-button g-button g-button-earth"
                            [disabled]="form.invalid"
                            (click)=addListItem()>
                        <span class="g-button-title">
                          {{ 'common_finish_do' | translate }}
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
